export const formatPercent = (ratio: number): string =>
  ratio.toLocaleString("en-US", {
    style: "percent",
    maximumFractionDigits: 1,
  });
